export const CONFIGSiteTitle = "FFG Star Wars/Genesys Helpers";